




















import { Emit, Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import FileGallery from "@/custom/page/filemanager/file/FileGallery.vue";
import FileCard from "@/custom/page/filemanager/file/FileCard.vue";
import ProjectService from "@/entities/project/project.service";
import { viewPageToQueryPage } from "@/constants";
import { IProject } from "@/shared/model/project.model";
import FileGeodeticService from "@/entities/file-geodetic/file-geodetic.service";
import { IFileGeodetic } from "@/shared/model/file-geodetic.model";
import Map2dService from "@/entities/map-2-d/map-2-d.service";
import Vr360Service from "@/entities/vr-360/vr-360.service";
import Model3dService from "@/entities/model-3-d/model-3-d.service";

@Component({
  components: { FileCard, FileGallery },
})
export default class GeodeticProjectViewList extends Vue {
  projects: IProject[] = [];

  projectToFiles = {};
  projectToMap2d = {};
  projectToModel3d = {};
  projectToVr360 = {};

  projectPage = {
    page: 1,
    size: 20,
    total: 20,
  };

  @Watch('projectPage.size')
  @Watch('projectPage.page')
  async fetchProject() {
    let projectService = new ProjectService();
    let rs = await projectService.retrieve(viewPageToQueryPage(this.projectPage));
    this.projects = rs.data;
    this.projectPage.total = parseInt(rs.headers['x-total-count']);

    let fileGeodeticService = new FileGeodeticService();
    let fileGeodeticRs = await fileGeodeticService.retrieve();
    await this.updateDataMap(fileGeodeticRs, this.projectToFiles);

    let map2dService = new Map2dService();
    let map2dRs = await map2dService.retrieve();
    await this.updateDataMap(map2dRs, this.projectToMap2d);

    let vr360Service = new Vr360Service();
    let vr360Rs = await vr360Service.retrieve();
    await this.updateDataMap(vr360Rs, this.projectToVr360);

    let model3dService = new Model3dService();
    let model3dRs = await model3dService.retrieve();
    await this.updateDataMap(model3dRs, this.projectToModel3d);
  }

  getImgThumbnailUrl(item: IFileGeodetic) {
    const fileGeodeticService = new FileGeodeticService();
    return fileGeodeticService.thumbnail(item.id);
  }

  async updateDataMap(rs, map) {
    rs.data.forEach(f => {
      let projectId = f.project.id;
      map[projectId] = map[projectId] || {};
      map[projectId].list = map[projectId].list || [];
      map[projectId].list.push(f);
      map[projectId].total = parseInt(rs.headers['x-total-count']);
    });
  }

  mounted() {
    this.fetchProject();
  }

  openProjectPage(project) {
    this.$router.push({ name: 'ProjectFilesDetailMapListViewer', params: { projectId: project.id } });
  }

  @Emit()
  updateMenuSelect() {}
}
